type EntityProps = { id: string } & Record<string, unknown>;

class Entity {
    id!: string;
    [key: string]: unknown;
    [key: symbol]: unknown;

    /**
     * @param props - ID string or an object with an `id` string property
     */
    constructor(props: string | EntityProps) {
        if (typeof props === 'string') {
            this.id = props;
        } else if (typeof props === 'object') {
            if (!props.id) {
                throw new Error('Entity initializer object must have id property');
            }
            Object.assign(this, props);
            if (typeof this.id !== 'string') {
                throw new Error('Entity ID must be a string');
            }
        } else {
            throw new Error('Entity must be constructed with ID or initializer object');
        }

        this[Entity.meta] = {};
    }

    /**
     * Symbol key for the internal metadata object on each entity instance.
     */
    static readonly meta = Symbol('entityMetadata');
}

export default Entity;
